import { AzureDataExplorerLinkedService } from '../linkedservice/azure-data-explorer.linkedservice';
import { Metamodel } from '../base/model';
import { IAttribute, IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format, sanitizeAndFormatString, stringIsNullOrEmpty } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ConnectionKind } from '../../constants/linkedservice-constants';

@Metamodel.model({
    name: ModelConstants.azureDataExplorerDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.AzureDataExplorer_DisplayText),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.AzureDataExplorer_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AzureDataExplorerLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzureDataExplorerDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public static DATABASE: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.Database,
        templatable: true,
        association: 'DATABASE',
        constraint: {
            validator: (dataset: AzureDataExplorerDataset, database: string) => {
                if (
                    dataset.linkedService?.tridentConnectionKind === ConnectionKind.AZURE_DATA_EXPLORER &&
                    stringIsNullOrEmpty(database)
                ) {
                    return [
                        {
                            context: dataset,
                            message: () =>
                                sanitizeAndFormatString(
                                    shellStringResources.RequiredTemplate,
                                    shellStringResources.Database
                                ),
                            messageType: 'missing'
                        }
                    ];
                }
                return undefined;
            }
        }
    })
    public database?: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
